<template>
  <b-col md="4">
    <b-card class="mb-2">
      <b-tabs>
        <b-tab
          id="tab-right-1"
          title="ดำเนินการ"
        >
          <b-row>
            <p>ความละเอียดแจ้งอยู่แล้ว นั้น</p>

            <b-col cols="12 mt-2">
              <b-form-group
                label="ตามหนังสืออ้างอิง ท่านร้องทุกข์ว่า"
                label-for="offficerComment"
              >
                <b-form-textarea
                  id="offficerComment"
                  placeholder="ตามหนังสืออ้างอิง"
                  rows="6"
                />
              </b-form-group>

              <p>ความละเอียดแจ้งอยู่แล้ว นั้น</p>

              <b-form-group
                label="สำนักงานคณะกรรมการคุ้มครองผู้บริโภค พิจารณาแล้ว เห็นว่า"
                label-for="offficerComment2"
              >
                <b-form-textarea
                  id="offficerComment2"
                  placeholder=""
                  rows="6"
                />
              </b-form-group>
              <b-form-group
                label="สาเหตุการยกเลิก"
              >
                <b-col cols="12">
                  <b-form-select
                    v-model="selectedReason"
                    :options="optionSendType"
                    class="mt-1"
                  />
                </b-col>
              </b-form-group>
              <b-form-file
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-col>

            <b-col
              cols="12"
              class="d-flex justify-content-between mt-2"
            >
              <b-button
                variant="secondary"
                @click="onCancelBtnCliked"
              >
                ยกเลิก </b-button>
              <b-button
                variant="primary"
                @click="onSubmitBtnCliked"
              >
                บันทึก
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab
          id="tab-right-2"
          title="ประวัติ"
        />
      </b-tabs>
    </b-card>
  </b-col>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BFormGroup,
  BFormInput,
  BTab,
  BTabs,
  BCard,
  BFormRadioGroup,
  BFormSelect,
  BFormFile,
  BButton,
  BFormRadio,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormRadioGroup,
    BFormSelect,
    BFormFile,
    BButton,
    BFormRadio,
  },
  data() {
    return {
      optionSendType: [
        { text: 'ผู้ร้องไกล่เกลี่ยกันได้', value: null },
        { text: 'ผู้ร้องไกล่เกลี่ยกันได้', value: 2 },
        { text: 'ผู้ร้องไกล่เกลี่ยกันได้', value: 3 },
        { text: 'ผู้ร้องไกล่เกลี่ยกันได้', value: 4 },
      ],
      optionSendOrg: [
        {
          text: 'หน่วยงานภายใน',
          value: 1,
          selectOptions: [
            {
              text: 'หน่วยงาน',
              value: null,
            },
            {
              text: 'หน่วยงาน1',
              value: 1,
            },
          ],
          selectedOption: null,
        },
        {
          text: 'จังหวัด',
          value: 2,
          selectOptions: [
            {
              text: 'จังหวัด',
              value: null,
            },
            {
              text: 'ราชบุรี',
              value: 1,
            },
          ],
          selectedOption: null,
        },
        {
          text: 'หน่วยงานภายนอก',
          value: 3,
          selectOptions: [
            {
              text: 'จังหวัด',
              value: null,
            },
            {
              text: 'ราชบุรี',
              value: 1,
            },
          ],
          selectedOption: null,
        },
      ],
      selectReasons: [
        { text: 'สาเหตุ', value: null },
        { text: 'สาเหตุ1', value: 1 },
        { text: 'สาเหตุ2', value: 2 },
      ],
      selected: 1,
      selectSend: 1,
      selectedReason: null,
    }
  },
  methods: {
    onSubmitBtnCliked() {
      window.open(this.$router.resolve({ name: 'CancelledForm' }).href, '_self')
    },
    onCancelBtnCliked() {
      window.open(this.$router.resolve({ name: 'ScreeningManage', query: { id: 1 } }).href, '_self')
    },
  },
}
</script>

<style></style>
